export default __webpack_public_path__ + "locales/sl/ConvertDialog.json?hash=a97fdea0a6d041fc44d73e8c5fb73af7";